<template>
	<component
		:is="tag"
		:to="href"
		:class="['logo', modifierString]"
		@click="onClick"
	> <slot /></component>
</template>

<script src="./Logo.js"></script>
